export default "__VITE_ASSET__CUeGd4Vy__"